import React, { Component } from 'react';
import qs from 'qs';

import Filters from '../filters/filters';
import ClinicalFilters from '../filters/clinicalFilters';
import CellModelList from '../model-list/modelList';
import ModelListHeader from '../model-list/modelListHeader';
import ModelListFooter from '../model-list/modelListFooter';

import { Col, Container, Row } from "reactstrap";
import { api_base_url } from "../../settings";
import { alphabetically, api_fetch } from "../../utils";

import Deserialiser from 'deserialise-jsonapi';
import { Link } from "react-router-dom";

const des = new Deserialiser();


const BASE_QUERY = {
    include:
        "sample.patient,sample.tissue,sample.cancer_type,sample.ncit,model_msi_status,identifiers.source",

    "fields[model]":
        "names,sample,model_type,mutations_available,cnv_available,drugs_available,methylation_available,expression_available,crispr_ko_available,fusions_available,proteomics_available,ploidy,ploidy_wgs,ploidy_wes,mutations_per_mb,model_msi_status,commercial_available,identifiers",

    "fields[sample]":
        "tissue,cancer_type,ncit,tissue_status,age_at_sampling,patient,sample_site,tnm_integrated,metastasis_at_diagnosis,prior_treatment,sample_treatment",

    "fields[patient]":
        "ethnicity,gender,alcohol_exposure_intensity,smoking_status,prior_malignancies",

    "fields[tissue]":
        "name",

    "fields[model_msi_status]":
        "msi_status,current",

    "fields[cancer_type]":
        "name"
};


class Passports extends Component {

    constructor(props) {
        super(props);

        this.requestCallbacks = [];
        this.responseCallbacks = [];

        this.state = {
            models: [],
            loading: false
        };

        this.lastSearch = null;

        this.fetchModels = this.fetchModels.bind(this);
        this.generateAPIURL = this.generateAPIURL.bind(this);
        this.registerRequestCallback = this.registerRequestCallback.bind(this);
        this.unregisterRequestCallback = this.unregisterRequestCallback.bind(this);
        this.registerResponseCallback = this.registerResponseCallback.bind(this);
        this.unregisterResponseCallback = this.unregisterResponseCallback.bind(this);
    }


    generateAPIURL() {

        let api_qs = {
            ...BASE_QUERY
        };


        /*
         * Every registered filter gets a chance to modify
         * the same query object.
         */
        let aggregations = {};

this.requestCallbacks.forEach(fun => {

    if (typeof fun !== 'function') {
        return;
    }

    const result = fun(
        api_qs,
        this.props,
        this.state
    );

    if (result && result.api_qs) {
        api_qs = result.api_qs;
    }

    if (result && result.agg) {
        aggregations = {
            ...aggregations,
            ...result.agg
        };
    }
});


        const current_qs = qs.parse(
            this.props.location.search,
            {
                ignoreQueryPrefix: true
            }
        );


        if (current_qs.q) {
            api_qs.q = current_qs.q;
        }


        /*
         * Aggregations are now only added by filters that
         * actually need them.
         */
        if (
            api_qs.agg &&
            Object.keys(api_qs.agg).length > 0
        ) {
            api_qs.agg = JSON.stringify(api_qs.agg);
        }


        if (
            api_qs.filter &&
            api_qs.filter.length > 0
        ) {
            api_qs.filter = JSON.stringify(
                api_qs.filter
            );
        }


        api_qs.sort = api_qs.sort || "names";


        return api_base_url +
            "/models" +
            qs.stringify(
                api_qs,
                {
                    depth: 0,
                    addQueryPrefix: true,
                    sort: alphabetically
                }
            );
    }


    registerRequestCallback(callback) {

        this.requestCallbacks.push(callback);
    }


    unregisterRequestCallback(callback) {

        const index =
            this.requestCallbacks.indexOf(callback);

        if (index !== -1) {
            this.requestCallbacks.splice(index, 1);
        }
    }


    registerResponseCallback(callback) {

        this.responseCallbacks.push(callback);
    }


    unregisterResponseCallback(callback) {

        const index =
            this.responseCallbacks.indexOf(callback);

        if (index !== -1) {
            this.responseCallbacks.splice(index, 1);
        }
    }


    fetchModels() {

        const apiurl = this.generateAPIURL();


        this.setState({
            loading: true
        });


        return api_fetch(apiurl)

            .then(response => response.json())

            .then(data => {

                this.responseCallbacks.forEach(fun => {

                    if (typeof fun === 'function') {
                        fun(data);
                    }

                });


                return des.deserialise(data);
            })

            .then(models => {

                this.setState({
                    models,
                    loading: false
                });

            })

            .catch(error => {

                console.error(
                    "Failed to fetch models",
                    error
                );

                this.setState({
                    models: [],
                    loading: false
                });

            });
    }


    componentDidMount() {

        this.fetchModels();
    }


    componentDidUpdate(prevProps) {

        if (
            prevProps.location.search !==
            this.props.location.search
        ) {

            this.fetchModels();
        }
    }


    componentWillUnmount() {

        this.requestCallbacks = [];
        this.responseCallbacks = [];
    }


    render() {

        return (

            <Container
                className="bg-faded z0"
                fluid
            >

                <Row>

                    <Col
                        md="12"
                        lg="3"
                        xl="3"
                        className="bg-white filter-sidebar py-5"
                    >

                        <div className="sticky-top">

                            <div className="d-flex flex-row justify-content-between">

                                <h4 className="bold ml-3 pl-1">
                                    Model list filters
                                </h4>

                                <Link
                                    to="/passports"
                                    className="small mr-3 pr-1"
                                >
                                    reset all
                                </Link>

                            </div>


                            <Filters
                                registerRequest={
                                    this.registerRequestCallback
                                }

                                registerResponse={
                                    this.registerResponseCallback
                                }

                                unregisterRequest={
                                    this.unregisterRequestCallback
                                }

                                unregisterResponse={
                                    this.unregisterResponseCallback
                                }

                                requestAggregation={
                                    this.fetchModels
                                }
                            />


                            <br />
                            <br />


                            <div className="d-flex flex-row justify-content-between">

                                <h4 className="bold ml-3 pl-1">
                                    Clinical data filters
                                </h4>

                            </div>


                            <ClinicalFilters
                                registerRequest={
                                    this.registerRequestCallback
                                }

                                registerResponse={
                                    this.registerResponseCallback
                                }

                                unregisterRequest={
                                    this.unregisterRequestCallback
                                }

                                unregisterResponse={
                                    this.unregisterResponseCallback
                                }

                                requestAggregation={
                                    this.fetchModels
                                }
                            />

                        </div>

                    </Col>


                    <Col className="py-4">

                        <ModelListHeader
                            registerRequest={
                                this.registerRequestCallback
                            }

                            registerResponse={
                                this.registerResponseCallback
                            }

                            unregisterRequest={
                                this.unregisterRequestCallback
                            }

                            unregisterResponse={
                                this.unregisterResponseCallback
                            }

                            models={this.state.models.length}
                        />


                        <CellModelList
                            models={this.state.models}
                            loading={this.state.loading}
                        />


                        <ModelListFooter
                            registerRequest={
                                this.registerRequestCallback
                            }

                            registerResponse={
                                this.registerResponseCallback
                            }

                            unregisterRequest={
                                this.unregisterRequestCallback
                            }

                            unregisterResponse={
                                this.unregisterResponseCallback
                            }
                        />

                    </Col>

                </Row>

            </Container>
        );
    }
}


export default Passports;